<script setup lang="ts">
import { VueperSlides, VueperSlide } from 'vueperslides'
import { useScreen } from '@/composables/useScreen'

const reviews = [
  {
    name: 'Laimonas Stakėnas',
    value: 5,
    description: 'customer_review_description1',
    image: (await import('@/assets/images/Reviewers/reviewer1.jpg')).default
  },
  {
    name: 'Valdas Skirmantas',
    position: 'customer_review_position2',
    value: 5,
    description: 'customer_review_description2',
    image: (await import('@/assets/images/Reviewers/reviewer2.png')).default
  }
]

const { isMobileView } = useScreen()
const arrowShift = computed(() => 45 + reviews.length * (isMobileView.value? 34 : 44) / 2)
const isAutoplayActive = computed(() => reviews.length > 1)
</script>
<template>
  <div class="bg-darkBlue pt-20 pb-20 text-white">
    <div class="text-36 lg:text-60 font-redhat font-semibold flex items-center justify-center leading-tight">
      {{ $t('what_our_customers_say') }}
    </div>
    <div class="mt-4 flex items-center justify-center">
      <div class="text-md font-redhat leading-normal w-[327px] lg:w-[450px]">
        {{ $t('what_our_customers_say_description') }}
      </div>
    </div>
    <div>
      <vueper-slides
        class="no-shadow"
        :visible-slides="1"
        :gap="0"
        :fixed-height="isMobileView? '880px' : '490px'"
        :autoplay="isAutoplayActive"
        :touchable="isMobileView"
        :dragging-distance="10"
        :duration="5000"
      >
        <template #bullet="{ active }">
          <div class="relative lg:mb-[18px] w-[25px] lg:w-[35px] h-1 -mx-[6px] top-12 lg:top-14 bg-white" :class="{'opacity-55' : !active}" />
        </template>
        <template #arrow-left>
          <div class="relative top-[462px] lg:top-[257px]" :style="{left: `-${arrowShift}px`}">
            <IconArrowFullLeft class="text-white" />
          </div>
        </template>
        <template #arrow-right>
          <div class="relative top-[462px] lg:top-[257px]" :style="{right: `-${arrowShift}px`}">
            <IconArrowFullRight class="text-white" />
          </div>
        </template>
        <vueper-slide v-for="(review, index) in reviews" :key="index">
          <template #content>
            <div class="flex items-center justify-center">
              <div class="lg:flex mt-10 lg:mt-16">
                <div class="flex items-center justify-center">
                  <img width="327" height="393" class="rounded-[40px]" :src="review.image">
                </div>
                <div class="ml-6 lg:ml-8 mt-8 w-[327px] lg:w-[626px]">
                  <div>
                    <rating-stars :value="review.value" :text-size="24" :filled-star-class="'text-lightBlue mr-1.5'" />
                  </div>
                  <div class="mt-4 lg:mt-8 text-md leading-normal font-redhat">
                    {{ $t(review.description) }}
                  </div>
                  <div class="mt-4 lg:mt-8 text-2xlg font-redhat font-semibold">
                    {{ review.name }}
                  </div>
                  <div v-if="review.position">
                    {{ $t(review.position) }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </div>
  </div>
</template>
<style scoped>
:deep(.vueperslides__arrow) {
  opacity: 1;
}

:deep(.vueperslides__arrow--prev) {
  left: 50%;
}

:deep(.vueperslides__arrow--next) {
  right: 50%;
}
</style>
